<template>
    <div class="mb-6">
        <div v-for="(group, groupIndex) in optionGroups"
            :key="group.code"
            :class="{
                'mt-4': groupIndex > 0,
            }"
        >
            <div class="mb-2 flex justify-between text-sm font-gotham">
                <label v-if="canShowGroupLabels" class="font-bold mr-2">
                    {{customizerStore.useTranslations(`logoGroup_${group.group}`, group.label)}}
                </label>

                <!-- No selected names for logos, not user friendly -->
                <!--
                <label
                    v-if="group.containsSelected"
                    class="font-light overflow-hidden whitespace-nowrap text-ellipsis"
                >
                    {{group.placement.selectedName}}
                </label>
                -->
            </div>

            <swatch-button-group
                :option-name="group.placement.code"
                :options="group.components"
                :selected-value="group.placement.selectedValue"
                :variant="getPlacementVariant(group.placement)"
                :hide-labels="true"
                :allow-debug-mode="false"
                @selection-changed="selectValue(group.placement, $event)"
            />
        </div>
    </div>
</template>

<script>
    import SwatchButtonGroup from './SwatchButtonGroup.vue';

    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        components: {
            SwatchButtonGroup,
        },

        props: {
            placement: {
                type: Object,
                required: true,
            },
            mirror: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            hiddenLogos() {
                return this.customizerStore.hiddenLogos;
            },

            canShowGroupLabels() {
                return !(this.customizerStore.options?.package?.length > 0);
            },

            /**
             * Group options according to WebTop style option groups.
             */
            optionGroups() {
                const groups = {};

                const { placement } = this;

                const allowedLogos = this.customizerStore.allowedLogos;

                placement.components.forEach((component) => {
                    if (component.placeholder) {
                        return;
                    }

                    const ecomValue = component.custom['fj-parameter-value'];
                    if (!allowedLogos.has(ecomValue)) {
                        return;
                    }

                    if (this.hiddenLogos?.includes(ecomValue)) {
                        return;
                    }

                    const groupType = component.custom?.['fj-logo-group'];

                    let group = groups[groupType];

                    if (group == null) {
                        group = {
                            code: `${placement.code}-${groupType}`,
                            placement,

                            groupType,
                            group: component.custom?.['fj-logo-group'],
                            label: component.custom?.['fj-logo-group-label'],
                            components: [],
                        };

                        groups[groupType] = group;
                    }

                    group.components.push(component);
                });

                return Object.values(groups)
                    .map((group) => {
                        group.containsSelected = group.components.some((component) => component.code === group.placement.selectedValue);

                        return group;
                    })
                    .filter((group) => group.components.length > 0);
            },
        },

        methods: {
            getPlacementVariant() {
                return 'small';
            },

            selectValue(placement, option) {
                this.customizerStore.setSelection(placement.code, option.value, false);

                if (this.mirror) {
                    // Find a similar placement on the other side.
                    let otherSide;

                    if (placement.code === 'MONOGRAMMINGLOGO11') {
                        otherSide = this.viewController.findPlacement('MONOGRAMMINGLOGO21');
                    } else {
                        otherSide = this.viewController.findPlacement('MONOGRAMMINGLOGO11');
                    }

                    const otherComponent = otherSide.components.find((x) => x.placementIndependentCode === option.placementIndependentCode);

                    if (otherComponent) {
                        // No undo for this.
                        this.viewController.updateComponent(otherSide.code, otherComponent.code);
                    }
                }
            },
        },
    };
</script>
